export enum OrgPermission {
  Apideck = 'apideck',
  AnthropicModels = 'anthropicModels',
  Inconsistencies = 'inconsistencies',
  GeminiModels = 'geminiModels',
  UkOnly = 'ukOnly',
  RelativityUsage = 'relativityUsage',
  AdminApproval = 'adminApproval',
  Require2FANonSSO = 'require2faNonSSO',
}
